<template>
  <v-container class="px-5 px-md-18 py-14 py-md-8">
    <v-card-title
      class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
    >
      Payment
      <v-progress-linear v-if="sendingEmail" indeterminate />
    </v-card-title>
    <v-col class="pa-0">
      <v-card-title
        class="py-0 px-0 mb-4 title font-weight-bold letter-spacing-normal"
      >
        Receipt Summary
      </v-card-title>
    </v-col>

    <v-card tile>
      <div
        class="justify-space-between align-items-center align-content-center d-flex py-4 mb-4 border-bottom--1  px-xl-12 px-lg-5"
      >
        <div class="text-left font-weight-bold">Contribution Amount</div>
        <div class="text-right font-weight-bold">
          USD $
          <input ref="price" v-model="request.amount" type="number" />
        </div>
      </div>
    </v-card>

    <v-card>
      <v-tabs
        v-model="tab"
        background-color="#125cd3"
        centered
        dark
        icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="option in paymentOption"
          :key="option.value"
          :href="`#` + option.value"
        >
          {{ option.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="option in paymentOption"
          :key="option.value"
          :value="option.value"
        >
          <v-list flat color="white">
            <v-list-item
              :ripple="false"
              inactive
              class="justify-space-between px-xl-12 px-lg-5"
            >
              <div class="text-left">Service Charge ({{ serviceCharge }}%)</div>

              <div class="text-right notranslate">
                {{ chargeBreakDown.service }}
              </div>
            </v-list-item>

            <v-list-item
              v-if="tab === 'credit-card'"
              :ripple="false"
              inactive
              class="justify-space-between px-xl-12 px-lg-5"
            >
              <div class="text-left">Stripe Charge ({{ stripeCharge }}%)</div>

              <div class="text-right notranslate">
                {{ chargeBreakDown.stripe }}
              </div>
            </v-list-item>

            <v-list-item
              :ripple="false"
              inactive
              class="justify-space-between px-xl-12 px-lg-5"
            >
              <div class="text-left">Project</div>

              <div class="text-right notranslate">
                {{ chargeBreakDown.project }}
              </div>
            </v-list-item>
            <v-list-item
              :ripple="false"
              inactive
              class="justify-space-between px-xl-12 px-lg-5"
            >
              <div class="text-left font-weight-bold">Total</div>

              <div class="text-right notranslate">
                {{ chargeBreakDown.total }}
              </div>
            </v-list-item>
            <VDivider />
          </v-list>
          <v-list
            v-if="option.value === 'cash'"
            flat
            color="white"
            class="mb-8 "
          >
            <v-list-item
              :ripple="false"
              inactive
              class="flex-column flex-md-row justify-lg-space-between px-xl-12 px-lg-5 pt-4 mb-2"
            >
              <div class="text-left font-weight-bold mb-3 mb-md-0">Cash</div>
              <div class="text-right">
                <v-btn
                  default
                  light
                  color="white px-5 border-radius-50 font-weight-bold"
                  min-height="50"
                  min-width="200"
                  :loading="sendingEmail"
                  @click="authenticate()"
                >
                  Authenticate
                </v-btn>
              </div>
            </v-list-item>
          </v-list>
          <div v-if="tab === 'credit-card'" class="pa-4">
            <stripe-pay v-if="option.value === 'credit-card'" />
          </div>

          <div v-if="tab === 'stripe-invoice'">
            <v-card variant="tonal" elevation="0" class="px-xl-8 px-lg-2">
              <v-card-title>Pay via invoice</v-card-title>
              <v-card-text>
                <v-icon color="info">$information</v-icon>
                Invoice will be sent to the respective email address for each
                individuals.
              </v-card-text>
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import StripePay from '@pages/groups/_partials/_partials/StripePay';

const SERVICE_CHARGE = 17;
const STRIPE_CHARGE = 3;

export default {
  name: 'Payment',
  components: { StripePay },
  props: {
    sendingEmail: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chargeBreakDown() {
      const options = { style: 'currency', currency: 'USD' };
      const formatter = new Intl.NumberFormat('en-US', options).format;
      const serviceCharge = (SERVICE_CHARGE / 100) * this.request.amount;
      const stripeCharge =
        this.tab === 'credit-card'
          ? (STRIPE_CHARGE / 100) * this.request.amount
          : 0;
      const donationAmount = this.request.amount - stripeCharge - serviceCharge;

      return {
        service: formatter(serviceCharge),
        stripe: formatter(stripeCharge),
        project: formatter(donationAmount),
        total: formatter(this.request.amount),
      };
    },
  },
  data() {
    return {
      complete: false,
      tab: null,
      serviceCharge: SERVICE_CHARGE,
      stripeCharge: STRIPE_CHARGE,
      paymentOption: [
        { name: 'Cash', value: 'cash' },
        {
          name: 'Credit Card',
          value: 'credit-card',
        },
        {
          name: 'Invoice',
          value: 'stripe-invoice',
        },
      ],
    };
  },
  methods: {
    authenticate() {
      this.$emit('next');
    },
  },
  watch: {
    tab: function(value) {
      this.$emit('paymentType', value);
    },
  },
  mounted() {
    if (this.currentUser.isTourist()) {
      this.paymentOption.shift();
    }
    this.$refs.price.focus();
  },
};
</script>

<style lang="scss" scoped>
input[type='number'] {
  background-color: #d9d9d9;
  border-style: solid;
  border-radius: 10px;
  width: 30%;
  text-align: center;
}
</style>
